import toast from "react-hot-toast";
import * as api from "../Api";

export const impairInvestment = (id, postData) => async (dispatch) => {
  let impairingId;
  try {
    impairingId = toast.loading("Impairing investment...");
    const { data } = await api.updateInvestment(id, postData);
    dispatch({ type: "IMPAIR_INVESTMENT", payload: data });
    toast.remove(impairingId);
    toast.success("Investment Successfully Impaired ");
  } catch (error) {
    toast.remove(impairingId);
    toast.error(error.message);
  }
};

export const getImpairedInvestments = () => async (dispatch) => {
  try {
    const { data } = await api.getImpairedInvestments();
    dispatch({ type: "ALL_IMPAIRED_INVESTMENT", payload: data });
  } catch (error) {}
};
